<template>
<div class="delete-btns-content">
    <!-- 删除框 -->
    <div :class="showBatchDel&&showDelBtn?'delete-btns-show':'delete-btns-hide'">
        <button class="cancel-btn" @click="cancel()">{{$t('language.common.cancel')}}</button>
        <button class="delete-btn" @click="openDeleteDialog()" :disabled="size<1">{{$t('language.common.delete')+(size > 0?("(" + size + ")"):"")}}</button>
    </div>
</div>
</template>
<script>
export default ({
    name: "taskDeleteBtnsTab",
    props: ['deleteList','showBatchDel','showDelBtn'],
    data: function () {
        return {
            size: 0,//删除任务数量
        }
    },
    watch: {
        deleteList: {
            handler(value) {
                if(value.length){
                    this.size = value.length;
                }else{
                    this.size = 0;
                }
            }
        }
    },
    methods: {
        //打开确认弹窗
        openDeleteDialog() {
            this.$parent.showDelBtn = false;
            this.$parent.deleteAllItem();
        },
        //关闭删除状态
        cancel() {
            this.$parent.showDelBtn = false;
            this.$parent.showBatchDel = false;
            this.$parent.checkDeleteList = [];
        },
    }
})
</script>

<style scoped>
.delete-btns-content {
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 10;
}

.delete-btns-hide {
    display: none;
}

.delete-btns-show {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 90px;
    /*no*/
    background: #FFFFFF;
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: #D3DCF0;
    box-shadow: 0px -4px 10px 0px rgba(101, 116, 207, 0.2);
    animation: show-delete-btns .5s linear;
}

@keyframes show-delete-btns {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0);
    }
}

.delete-btns-content button {
    min-width: 160px;
    /*no*/
    height: 50px;
    /*no*/
    border-radius: 8px;
    /*no*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 30px;
    /*no*/
    gap: 5px 10px;
    /*no*/
    flex-wrap: wrap;
    align-content: center;
    box-sizing: border-box;
    margin: 0 10px;
    /*no*/
    font-size: 16px;
    /*no*/
}

.cancel-btn {
    border: 1px solid #C1CBE3;
    /*no*/
    background: #ffffff;
    color: #5562B4;
}

.delete-btn {
    background: #FD5236;
}

.delete-btn:hover {
    background: #E34A30;
}

.delete-btn:active {
    background: #C9422B;
}

button[disabled] {
    pointer-events: none;
    opacity: 0.5; 
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_delete_btns.vue